import React from "react";
import { motion } from "framer-motion";
type ScarcityBarProps = {
  tone?: "light" | "dark";
};
const CLAIMED = 93;
const SPOTS_LEFT = 7;
export function ScarcityBar({
  tone = "light"
}: ScarcityBarProps) {
  const dark = tone === "dark";
  return <div className="mx-auto w-full max-w-xl" data-id="element-36" data-mp="2l2ts2l3lbppp">
      <div className="mb-2 flex items-center justify-between gap-3 text-[13px] font-bold sm:text-sm" data-id="element-37" data-mp="2q37ot6zqrd8f">
        <span className={`flex items-center gap-2 ${dark ? "text-white" : "text-ink"}`} data-id="element-38" data-mp="2b6gwtised3su">
          <span className="live-dot h-2.5 w-2.5 shrink-0 rounded-full bg-flame" aria-hidden="true" data-id="element-39" data-mp="2g6ctewyrlsyd" />
          Only {SPOTS_LEFT} spots left at the promo price
        </span>
        <span className="shrink-0 text-flame" data-id="element-40" data-mp="27555n8tvkaij">{CLAIMED}%</span>
      </div>
      <div className={`h-4 w-full overflow-hidden rounded-full ${dark ? "bg-white/15" : "bg-line"}`} role="progressbar" aria-valuenow={CLAIMED} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional access claimed" data-id="element-41" data-mp="275ew0xiu0jor">
        <motion.div className="h-full rounded-full bg-flame" initial={{
        width: "60%"
      }} whileInView={{
        width: `${CLAIMED}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 1.1,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-42" data-mp="33lk3kl55a5f5" />
      </div>
      <p className={`mt-2 text-center text-xs font-semibold uppercase tracking-wide ${dark ? "text-white/60" : "text-muted"}`} data-id="element-43" data-mp="38dblk7a8j2to">
        {CLAIMED}% of promotional access claimed
      </p>
    </div>;
}